import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VeranstaltungAuswaehlenPage } from './veranstaltung-auswaehlen.page';
import {StoreModule} from '@ngrx/store';
import {reducers} from './veranstaltung-auswaehlen.reducer';
import {EffectsModule} from '@ngrx/effects';
import {VeranstaltungAuswaehlenPageUiEffects} from './veranstaltung-auswaehlen.effects.ui';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {VeranstaltungenFunkprotokollAktuelleVeranstaltungenEffects, VeranstaltungenFunkprotokollBeendeteVeranstaltungenEffects} from '../../../client-ngrx/veranstaltungen';

const routes: Routes = [
  {
    path: '',
    component: VeranstaltungAuswaehlenPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    StoreModule.forFeature('VeranstaltungAuswaehlenPage', reducers),
    EffectsModule.forFeature([
      VeranstaltungAuswaehlenPageUiEffects,
      VeranstaltungenFunkprotokollAktuelleVeranstaltungenEffects,
      VeranstaltungenFunkprotokollBeendeteVeranstaltungenEffects
    ]),
    SopiComponentsModule.forRoot(),
  ],
  declarations: [VeranstaltungAuswaehlenPage]
})
export class VeranstaltungAuswaehlenPageModule {}
